import React, { useState, useEffect } from 'react';

export const ANIMATION_KEYS = {
  BUR_ONBOARDING: 'bur-onboarding',
  ROUTE_OPTIMISATION: 'route-optimisation',
  DRIVER_NEARBY: 'driver-nearby',
  DRAG_TO_SNAP: 'drag-to-snap',
};

const animationMap = {
  [ANIMATION_KEYS.BUR_ONBOARDING]: () =>
    import('public/animations/bur-onboarding-v2.json'),
  [ANIMATION_KEYS.ROUTE_OPTIMISATION]: () =>
    import('public/animations/route-optimisation.json'),
  [ANIMATION_KEYS.DRIVER_NEARBY]: () =>
    import('public/animations/driver-nearby.json'),
  [ANIMATION_KEYS.DRAG_TO_SNAP]: () =>
    import('public/animations/drag-to-snap.json'),
};

export const useLazyLoadLottie = (animationKey, props) => {
  const [isLottieReady, setIsLottieReady] = useState(false);
  const [Lottie, setLottie] = useState(null);
  const [animationData, setAnimationData] = useState(null);

  useEffect(
    () => {
      let mounted = true;

      const loadDependencies = async () => {
        const [lottieModule, animationModule] = await Promise.all([
          import('react-lottie'),
          animationMap[animationKey](),
        ]);

        if (mounted) {
          setLottie(() => lottieModule.default);
          setAnimationData(animationModule.default);
          setIsLottieReady(true);
        }
      };

      loadDependencies();

      return () => {
        mounted = false;
      };
    },
    [animationKey],
  );

  const LottieComponent =
    isLottieReady && Lottie
      ? React.memo(function renderLottieComponent() {
          return (
            <Lottie
              {...props}
              options={{
                ...props.options,
                animationData,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
            />
          );
        })
      : null;

  return {
    LottieComponent,
    isLoading: !isLottieReady,
  };
};

export default useLazyLoadLottie;
